import React, { Component } from 'react';
import SmoothScroll from 'smooth-scroll';

import Formula from '../Formula/Formula';

import './MetricsEquation.scss'

class MetricsEquation extends Component {
  constructor(props) {
    super(props);
    this.bottomSection = undefined;
    this.topSection = undefined;
  }

  componentDidMount() {
    this.smoothScroll = new SmoothScroll();
    this.$btn = document.getElementById('btn-moving');
    this.bottomSection = document.getElementById('bottom-section');
    this.topSection = document.getElementById('top-section');
    
    window.onscroll = () => {
      this._checkPositionScrollBtn();
    }
  }

  onMoveScroll = (event) => {
    const $btn = event.target;
    const moveToBottom = !$btn.classList.contains('to-top') ? true : false;
    let anchor = moveToBottom ? this.bottomSection : this.topSection;

    $btn.classList.toggle('to-top');
    this.smoothScroll.animateScroll(anchor, {
      offset: 70
    });
  }

  _checkPositionScrollBtn = () => {
    const $btn = this.$btn;
    const Y_POINT_CHANGE = 200;

    if ($btn.getBoundingClientRect().y < Y_POINT_CHANGE) {
      $btn.classList.add('to-top');
    } else {
      $btn.classList.remove('to-top');
    }
  }

  render() {
    return (
      <div className="metrics-equation" id="bottom-section">
        <div className="metrics-equation__inner">
          <div className="metrics-equation__name">Profit Per Paying User</div>
          <div className="metrics-equation__formula">
            <Formula />
          </div>
          <div className="metrics-equation__hide" id="btn-moving" onClick={ this.onMoveScroll }></div>
        </div>
      </div>
    )
  }
}

export default MetricsEquation;


// WEBPACK FOOTER //
// ./src/components/MetricsEquation/MetricsEquation.js